/* tslint:disable:max-line-length */
import { DefaultMessages, RequestOrganizationMessages } from '@sheerid/jslib';

type RecursivePartial<T> = {
    [P in keyof T]?: RecursivePartial<T[P]>;
};

type ThisProjectMessages = {
    locales: {
        en: string, // need to support `en` in additon to `en-US` for ADSK's requirements
        is: string, // need to support `is` for ADSK's requirements
        ro: string, // need to support `ro` for ADSK's requirements
    },
    countries: {
        CD: string, // the jslib doesn't include a country code for Democratic Republic of Congo
        CZ: string, // the jslib uses the incorrect country code for Czech Republic
        PS: string, // the jslib doesn't include a country code for Palestine
        SS: string, // the jslib doesn't include a country code for South Sudan
        TL: string, // the jslib doesn't include a country code for Timor-Leste
    },
};


type LibraryMessages = DefaultMessages & RequestOrganizationMessages;

export const koRequestOrgMessages: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    title: '학교 추가 요청하기',
    description: '아래 양식을 작성해 주십시오. 제출된 학교 추가가 보장되는 것은 아니지만, SheerID는 모든 요청을 조사 및 고려합니다.',
    noCountry: '학교의 국가를 찾을 수 없습니까? 귀하는 이 제안에 대한 자격이 없습니다',
    searchByOrgName: '학교를 찾을 수 없습니까? 이름으로 검색하기',
    completeRequest: '적격 또는 부적격 학교 목록에서 학교를 찾을 수 없습니까? 귀하의 요청 완료하기',
    submit: '제출하기',
    eligibleOrgs: '적격 학교 아이콘을 클릭하여 이름을 복사한 후 확인 양식으로 돌아갑니다.',
    ineligibleOrgs: '부적격 학교 죄송합니다. 이 학교의 학생들은 이 제안에 대한 자격이 없습니다.',
    none: '없음',
    country: '어느 학교에 다니십니까?',
    changeLanguage: '언어 변경',
    copied: '복사',
    firstName: '이름',
    lastName: '성',
    emailAddress: '이메일',
    poweredBy: 'SheerID가 제공하는 검증 서비스',
    fields: {
        countryPlaceholder: '국가 선택하기',
        domainLabel: '학교 웹사이트',
        domainPlaceholder: 'www.우리학교.kr',
        orgNameLabel: '학교 이름',
        orgNamePlaceholder: '내 학교',
    },
    step: {
        success: {
            title: '감사합니다.',
            description: '교육 기관 추가 요청이 접수되었습니다. 본 요청과 관련된 조사를 마칠 때까지 최대 7일 정도 걸릴 수 있습니다. 소속되신 학교가 오토데스크 제품에 대한 교육용 액세스 권한을 이용할 수 있는 적격한 교육 기관 목록에 반드시 추가된다는 보장은 없습니다.<br><br>원하신다면 다른 서브스크립션 옵션을 살펴보실 수 있습니다.',
        },
        error: {
            title: '예기치 못한 오류가 발생했습니다',
            description: '죄송하지만 귀하의 요청을 처리할 수 없습니다. 나중에 다시 시도해 주십시오.',
            seeingProblem: '이 문제가 계속 발생하는 경우',
            contactUs: '당사에 연락하십시오',
        },
    },
    errorId: {
        invalidCountry: '필수 필드입니다',
        invalidEmail: '잘못된 이메일',
        invalidFirstName: '잘못된 이름',
        invalidLastName: '잘못된 성',
        requiredField: '필수 필드입니다',
        invalidField: '필드가 유효하지 않습니다',
        invalidUrl: '잘못된 URL',
        tooManyResults: '검색 결과가 너무 많습니다. 구체적으로 다시 검색해 주십시오',
    },
    faq: 'SheerID 추가 학교 요청 FAQ',
    countries: {
        AD: '안도라',
        AE: '아랍 에미리트',
        AF: '아프가니스탄',
        AG: '앤티가 바부다',
        AI: '앵귈라',
        AL: '알바니아',
        AM: '아르메니아',
        AN: '네덜란드령 앤틸리스 제도',
        AO: '앙골라',
        AR: '아르헨티나',
        AS: '아메리칸 사모아',
        AT: '오스트리아',
        AU: '호주',
        AW: '아루바',
        AZ: '아제르바이잔',
        BA: '보스니아 헤르체고비나',
        BB: '바베이도스',
        BD: '방글라데시',
        BE: '벨기에',
        BF: '부키나 파소',
        BG: '불가리아',
        BH: '바레인',
        BI: '부룬디',
        BJ: '베냉',
        BM: '버뮤다',
        BN: '브루나이 다루살람',
        BO: '볼리비아',
        BR: '브라질',
        BS: '바하마',
        BT: '부탄',
        BV: '부베 섬',
        BW: '보츠와나',
        BY: '벨라루스',
        BZ: '벨리즈',
        CA: '캐나다',
        CD: '콩고 민주 공화국',
        CF: '중앙아프리카 공화국',
        CG: '콩고',
        CH: '스위스',
        CI: '아이보리코스트(코트디부아르)',
        CK: '쿡 제도',
        CL: '칠레',
        CM: '카메룬',
        CN: '중국',
        CO: '콜롬비아',
        CR: '코스타리카',
        CU: '쿠바',
        CV: '케이프베르데',
        CY: '키프로스',
        CZ: '체코 공화국',
        DE: '독일',
        DJ: '지부티',
        DK: '덴마크',
        DM: '도미니카',
        DO: '도미니카 공화국',
        DZ: '알제리',
        EC: '에콰도르',
        EE: '에스토니아',
        EG: '이집트',
        EH: '서사하라',
        ER: '에리트레아',
        ES: '스페인',
        ET: '에티오피아',
        FI: '핀란드',
        FJ: '피지',
        FK: '포클랜드 제도',
        FM: '미크로네시아',
        FO: '페로 제도',
        FR: '프랑스',
        GA: '가봉',
        GB: '영국',
        GD: '그레나다',
        GE: '조지야',
        GF: '프랑스령 가이아나',
        GH: '가나',
        GI: '지브롤터',
        GL: '그린란드',
        GM: '감비아',
        GN: '기니',
        GP: '과들루프(프랑스령)',
        GQ: '적도 기니',
        GR: '그리스',
        GS: '사우스 조지아 & 사우스 샌드위치 제도',
        GT: '과테말라',
        GU: '괌(미국)',
        GW: '기니 비사우',
        GY: '가이아나',
        HK: '홍콩',
        HM: '허드 맥도널드 제도',
        HN: '온두라스',
        HR: '크로아티아',
        HT: '아이티',
        HU: '헝가리',
        ID: '인도네시아',
        IE: '아일랜드',
        IL: '이스라엘',
        IN: '인도',
        IO: '영국령 인도양 지역',
        IQ: '이라크',
        IR: '이란',
        IS: '아이슬란드',
        IT: '이탈리아',
        JM: '자메이카',
        JO: '요르단',
        JP: '일본',
        KE: '케냐',
        KG: '키르기스스탄',
        KH: '캄보디아',
        KI: '키리바시',
        KM: '코모로',
        KN: '세인트 키츠 네비스 앵귈라',
        KP: '북한',
        KR: '대한민국',
        KW: '쿠웨이트',
        KY: '케이맨 제도',
        KZ: '카자흐스탄',
        LA: '라오스',
        LB: '레바논',
        LC: '세인트 루시아',
        LI: '리히텐슈타인',
        LK: '스리랑카',
        LR: '라이베리아',
        LS: '레소토',
        LT: '리투아니아',
        LU: '룩셈부르크',
        LV: '라트비아',
        LY: '리비아',
        MA: '모로코',
        MC: '모나코',
        MD: '몰다비아',
        ME: '몬테네그로',
        MG: '마다가스카르',
        MH: '마샬 제도',
        MK: '마케도니아',
        ML: '말리',
        MM: '미얀마',
        MN: '몽골리아',
        MO: '마카오',
        MP: '북 마리아나 제도',
        MQ: '마르티니크(프랑스령)',
        MR: '모리타니',
        MS: '몬트세랫',
        MT: '몰타',
        MU: '모리셔스',
        MV: '몰디브',
        MW: '말라위',
        MX: '멕시코',
        MY: '말레이시아',
        MZ: '모잠비크',
        NA: '나미비아',
        NC: '뉴칼레도니아(프랑스령)',
        NE: '니제르',
        NF: '노퍽 섬',
        NG: '나이지리아',
        NI: '니카라과',
        NL: '네덜란드',
        NO: '노르웨이',
        NP: '네팔',
        NR: '나우루',
        NU: '니우에',
        NZ: '뉴질랜드',
        OM: '오만',
        PA: '파나마',
        PE: '페루',
        PF: '폴리네시아(프랑스령)',
        PG: '파푸아 뉴기니',
        PH: '필리핀',
        PK: '파키스탄',
        PL: '폴란드',
        PM: '생피에르 미클롱',
        PN: '핏케언 섬',
        PR: '푸에르토리코',
        PS: '팔레스타인',
        PT: '포르투갈',
        PW: '팔라우',
        PY: '파라과이',
        QA: '카타르',
        RE: '리유니온(프랑스령)',
        RO: '루마니아',
        RS: '세르비아',
        RU: '러시아 연방',
        RW: '르완다',
        SA: '사우디 아라비아',
        SB: '솔로몬 제도',
        SC: '세이셸',
        SD: '수단',
        SE: '스웨덴',
        SG: '싱가포르',
        SH: '세인트 헬레나',
        SI: '슬로베니아',
        SK: '슬로바키아 공화국',
        SL: '시에라리온',
        SM: '산마리노',
        SN: '세네갈',
        SO: '소말리아',
        SR: '수리남',
        SS: '남 수단',
        ST: '생투메(상투메) 프린시 페',
        SV: '엘살바도르',
        SY: '시리아',
        SZ: '스와질란드',
        TC: '터크스 케이커스 제도',
        TD: '차드',
        TF: '프랑스령 남부 지역',
        TG: '토고',
        TH: '태국',
        TJ: '타지키스탄',
        TK: '토켈라우',
        TL: '동 티모르',
        TM: '투르크메니스탄',
        TN: '튀니지',
        TO: '통가',
        TR: '터키',
        TT: '트리니다드 토바고',
        TV: '투발루',
        TW: '대만',
        TZ: '탄자니아',
        UA: '우크라이나',
        UG: '우간다',
        UM: '미국령 군소 제도',
        US: '미국',
        UY: '우루과이',
        UZ: '우즈베키스탄',
        VA: '바티칸 시국',
        VC: '세인트 빈센트 그레나딘',
        VE: '베네수엘라',
        VG: '버진 제도(영국령)',
        VI: '버진 아일랜드(미국령)',
        VN: '베트남',
        VU: '바누아투',
        WF: '월리스 푸투나 제도',
        WS: '사모아',
        XK: '코소보',
        YE: '예멘',
        YT: '마요트',
        ZA: '남아프리카',
        ZM: '잠비아',
        ZW: '짐바브웨',
    },
    locales: {
        ar: '아랍어',
        bg: '불가리아어',
        cs: '체코어',
        da: '덴마크어',
        de: '독일어',
        el: '그리스어',
        'en-GB': '영어 (영국)',
        'en-US': '영어',
        'es-ES': '스페인어 (스페인)',
        es: '스페인어',
        fi: '핀란드어',
        'fr-CA': '프랑스어 (캐나다)',
        fr: '프랑스어',
        hr: '크로아티아어',
        hu: '헝가리어',
        id: '인도네시아어',
        is: '아이슬란드어',
        it: '이탈리아어',
        iw: '히브리어',
        ja: '일본어',
        ko: '한국어',
        lt: '리투아니아어',
        ms: '말레이어',
        nl: '네덜란드어',
        no: '노르웨이어',
        pl: '폴란드어',
        'pt-BR': '포르투갈어 (브라질)',
        pt: '포르투갈어',
        ro: '루마니아어',
        ru: '러시아어',
        sk: '슬로바키아어',
        sl: '슬로베니아어',
        sr: '세르비아어',
        sv: '스웨덴어',
        tr: '터키어',
        'zh-HK': '중국어(홍콩)',
        zh: '중국어(번체자)',
    },
};
